import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import './404.scss';

interface Props {}

export const Index404: FC<Props> = () => {
  const navigate = useNavigate();

  // 组件挂载时隐藏body滚动条，卸载时恢复
  useEffect(() => {
    document.body.classList.add('error-404-body');
    
    return () => {
      document.body.classList.remove('error-404-body');
    };
  }, []);

  // 手动跳转
  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="error-404-page">
      {/* 背景装饰 */}
      <div className="background-decoration">
        <div className="floating-icon icon-1">
          <i className="fas fa-exclamation-triangle"></i>
        </div>
        <div className="floating-icon icon-2">
          <i className="fas fa-question-circle"></i>
        </div>
        <div className="floating-icon icon-3">
          <i className="fas fa-exclamation"></i>
        </div>
        <div className="floating-icon icon-4">
          <i className="fas fa-times-circle"></i>
        </div>
      </div>

      {/* 主要内容 */}
      <div className="error-content">
        <h1 className="error-title">404</h1>
        <h2 className="error-subtitle">页面未找到</h2>
        <p className="error-description">
          抱歉，您访问的页面不存在或已被移动。
        </p>

        {/* 操作按钮 */}
        <div className="error-actions">
          <Button 
            size="large" 
            onClick={handleGoBack}
            className="action-btn back-btn"
          >
            <i className="fas fa-arrow-left"></i>
            返回
          </Button>
        </div>

        {/* 搜索建议 */}
        <div className="search-suggestion">
          <p className="suggestion-text">
            <i className="fas fa-lightbulb"></i>
            您可以尝试：
          </p>
          <ul className="suggestion-list">
            <li>
              <i className="fas fa-search"></i>
              检查网址是否正确
            </li>
            <li>
              <i className="fas fa-refresh"></i>
              刷新页面
            </li>
            <li>
              <i className="fas fa-envelope"></i>
              联系技术支持
            </li>
          </ul>
        </div>
      </div>

      {/* 底部装饰 */}
      <div className="bottom-decoration">
        <div className="decoration-line"></div>
        <div className="decoration-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};
